function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Energiebesparing-stroom",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Energiebesparing-%-dit-jaar",
  transform: "translate(1.000000, 1.000000)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2-Copy",
  stroke: "#485156"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.1664,12.2 L24.1664,1.4 C24.1646002,1.0070838 23.9708104,0.639868805 23.6474562,0.416645975 C23.324102,0.193423146 22.9120371,0.142395286 22.544,0.28 L9.344,7.112 C8.87757388,7.28789549 8.56818805,7.73351293 8.5664,8.232 L8.5664,14.6",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 20.5664,
  y1: 7.4,
  x2: 24.1664,
  y2: 7.4,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 18.1664,
  y1: 12.2,
  x2: 24.1664,
  y2: 12.2,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.1664,
  y1: 19.4,
  x2: 3.7664,
  y2: 19.4,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.1664,
  y1: 24.2,
  x2: 6.1664,
  y2: 24.2,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.1664,
  y1: 5.6496,
  x2: 12.1664,
  y2: 0.2016,
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1664,36.2 L12.1664,17 C12.1664,15.6745166 11.0918834,14.6 9.7664,14.6 L2.5664,14.6 C1.2409166,14.6 0.1664,15.6745166 0.1664,17 L0.1664,36.2 L14.5664,36.2",
  id: "Path"
})), /*#__PURE__*/React.createElement("path", {
  d: "M28.3337287,15 L19.1372818,26.2151111 C18.9912017,26.3970558 18.9587797,26.6510849 19.054102,26.8668327 C19.1494242,27.0825806 19.355285,27.2211049 19.5822461,27.2222222 L23.6662713,27.2222222 L23.6662713,37 L32.8627182,25.7848889 C33.0087983,25.6029442 33.0412203,25.3489151 32.945898,25.1331673 C32.8505758,24.9174194 32.644715,24.7788951 32.4177539,24.7777778 L28.3337287,24.7777778 L28.3337287,15 Z",
  id: "Path-Copy",
  stroke: "#425CD4"
})));
function SvgEnergiebesparingstroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "40px",
    viewBox: "0 0 36 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Energiebesparing stroom") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergiebesparingstroom);
export default __webpack_public_path__ + "static/media/Energiebesparing stroom.91e3e7503335d3e97aca349751c456d5.svg";
export { ForwardRef as ReactComponent };